// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"ba448e44","703":"ee6ddf75"}[chunkId] + ".chunk.js";
};